/**
 * NAGGAT SILVER — GLOBAL LOCALIZATION, MULTI-LANGUAGE ENGINE & SMART SCROLL RESTORATION
 * 1. Automatic 5-tier language detection & 13-language storefront translation engine
 * 2. Full RTL/LTR adaptation without breaking brand names, SKUs, discount codes, or checkout
 * 3. Smart Scroll Position Restoration across Homepage, Collections, Products, Search & Blog
 * 4. Seamless Onboarding Sequence: Existing XO Game -> Smart Language Selector -> Localized Storefront
 */
(function () {
  'use strict';

  var STORAGE_LANG_KEY = 'naggat_preferred_locale';
  var POPUP_DISMISSED_KEY = 'naggat_lang_popup_dismissed_v1';
  var SCROLL_STORE_KEY = 'naggat_scroll_positions_v2';
  var LAST_NAV_KEY = 'naggat_last_nav_context_v2';

  var SUPPORTED_LOCALES = [
    'en', 'ar', 'fr', 'de', 'es', 'it', 'pt-BR', 'tr', 'ru', 'nl', 'ja', 'zh-CN', 'ko'
  ];

  var COUNTRY_TO_LOCALE = {
    EG: 'ar', SA: 'ar', AE: 'ar', KW: 'ar', QA: 'ar', BH: 'ar', OM: 'ar', JO: 'ar', LB: 'ar', MA: 'ar', DZ: 'ar', TN: 'ar', IQ: 'ar', LY: 'ar', SD: 'ar', YE: 'ar', SY: 'ar', PS: 'ar',
    FR: 'fr', MC: 'fr', SN: 'fr', CI: 'fr',
    DE: 'de', AT: 'de', LI: 'de',
    ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es',
    IT: 'it', SM: 'it',
    BR: 'pt-BR', PT: 'pt-BR',
    TR: 'tr', AZ: 'tr',
    RU: 'ru', KZ: 'ru', BY: 'ru',
    NL: 'nl',
    JP: 'ja',
    CN: 'zh-CN', SG: 'zh-CN', TW: 'zh-CN', HK: 'zh-CN',
    KR: 'ko'
  };

  var ARABIC_COUNTRIES = {
    EG: true, SA: true, AE: true, KW: true, QA: true, BH: true, OM: true,
    JO: true, LB: true, MA: true, DZ: true, TN: true, IQ: true, LY: true,
    SD: true, YE: true, SY: true, PS: true
  };

  var COUNTRY_NAMES_EN = {
    EG: 'Egypt', SA: 'Saudi Arabia', AE: 'United Arab Emirates', KW: 'Kuwait',
    QA: 'Qatar', BH: 'Bahrain', OM: 'Oman', JO: 'Jordan', LB: 'Lebanon',
    MA: 'Morocco', DZ: 'Algeria', TN: 'Tunisia', IQ: 'Iraq', LY: 'Libya',
    FR: 'France', DE: 'Germany', ES: 'Spain', IT: 'Italy', BR: 'Brazil',
    TR: 'Turkey', RU: 'Russia', NL: 'Netherlands', JP: 'Japan', CN: 'China',
    KR: 'South Korea', GB: 'United Kingdom', US: 'United States', CA: 'Canada', AU: 'Australia'
  };

  /* Comprehensive Storefront Phrase Dictionary (English & Arabic source phrases -> 13 target languages) */
  var UI_TRANSLATIONS = {
    ar: {
      'Home': 'الرئيسية',
      'Shop': 'المتجر',
      'Catalog': 'الكتالوج',
      'Collections': 'المجموعات',
      'All Products': 'جميع المنتجات',
      'Products': 'المنتجات',
      'Contact': 'تواصل معنا',
      'About Us': 'من نحن',
      'Our Story': 'قصتنا',
      'Search': 'بحث',
      'Account': 'حسابي',
      'Cart': 'حقيبة التسوق',
      'Your Cart': 'حقيبة التسوق',
      'Your Shopping Bag': 'حقيبة التسوق',
      'Your cart is empty': 'حقيبة التسوق فارغة حالياً',
      'Continue Shopping': 'مواصلة التسوق',
      'Subtotal': 'المجموع الفرعي',
      'Checkout': 'تأكيد الطلب الآن',
      'Proceed to Checkout': 'تأكيد الطلب الآن',
      'CONFIRM NOW': 'تأكيد الطلب الآن',
      'Confirm Now': 'تأكيد الطلب الآن',
      'View Cart': 'عرض الحقيبة',
      'Add to Cart': 'أضف إلى الحقيبة',
      'Add to Bag': 'أضف إلى الحقيبة',
      'ADD TO CART': 'أضف إلى الحقيبة',
      'ADD TO BAG': 'أضف إلى الحقيبة',
      'Choose Options': 'اختر المقاس / الخيارات',
      'CHOOSE OPTIONS': 'اختر المقاس / الخيارات',
      'Buy It Now': 'اشترِ الآن',
      'BUY IT NOW': 'اشترِ الآن',
      'Sold Out': 'نفدت الكمية',
      'SOLD OUT': 'نفدت الكمية',
      'Unavailable': 'غير متوفر',
      'Sale': 'تخفيض',
      'SALE': 'تخفيض',
      'New': 'جديد',
      'NEW': 'جديد',
      'Best Sellers': 'الأكثر مبيعاً',
      'BEST SELLERS': 'الأكثر مبيعاً',
      'Featured Collection': 'تشكيلة مميزة',
      'Shop by Category': 'تسوق حسب الفئة',
      'Shop by Occasion': 'تسوق حسب المناسبة',
      'Explore Collection': 'استكشف المجموعة',
      'Shop Now': 'تسوق الآن',
      'SHOP NOW': 'تسوق الآن',
      'View All': 'عرض الكل',
      'VIEW ALL': 'عرض الكل',
      'Discover More': 'اكتشف المزيد',
      'Filter': 'تصفية',
      'Filter & Sort': 'تصفية وترتيب',
      'Sort by': 'الترتيب حسب',
      'Sort by:': 'الترتيب حسب:',
      'Featured': 'المميزة',
      'Best selling': 'الأكثر مبيعاً',
      'Alphabetically, A-Z': 'أبجدياً، أ - ي',
      'Alphabetically, Z-A': 'أبجدياً، ي - أ',
      'Price, low to high': 'السعر: من الأقل للأعلى',
      'Price, high to low': 'السعر: من الأعلى للأقل',
      'Date, old to new': 'التاريخ: من الأقدم للأحدث',
      'Date, new to old': 'التاريخ: من الأحدث للأقدم',
      'Clear all': 'مسح الكل',
      'Apply': 'تطبيق',
      'Quantity': 'الكمية',
      'Description': 'الوصف',
      'Details': 'التفاصيل',
      'Shipping & Returns': 'الشحن والاستبدال',
      'Care Instructions': 'تعليمات العناية بالفضة',
      'You May Also Like': 'قد يعجبك أيضاً',
      'Related Products': 'منتجات مشابهة',
      'Customer Reviews': 'آراء العملاء',
      'Quick Links': 'روابط سريعة',
      'Customer Care': 'خدمة العملاء',
      'Newsletter': 'النشرة البريدية',
      'Subscribe': 'اشتراك',
      'All rights reserved.': 'جميع الحقوق محفوظة.',
      'Privacy Policy': 'سياسة الخصوصية',
      'Refund Policy': 'سياسة الاستبدال والاسترجاع',
      'Shipping Policy': 'سياسة الشحن',
      'Terms of Service': 'الشروط والأحكام',
      'FOR HER': 'لها',
      'FOR HIM': 'له',
      'COUPLES GIFTS': 'هدايا الكابلز',
      'Rings': 'خواتم',
      'Chains': 'سلاسل',
      'Bracelets': 'أساور',
      'Jewelry Sets': 'أطقم فضة',
      'Watches': 'ساعات',
      'Bags': 'حقائب',
      'Perfumes': 'عطور',
      'Customer Designs, Cashback Rewards': 'تصاميم العملاء ومكافآت الكاش باك',
      'READ FULL ARTICLE →': 'اقرأ المقال كاملاً ←',
      '◄ PREV': '◄ السابق',
      'NEXT ►': 'التالي ►',
      'Order note': 'ملاحظات الطلب',
      'From': 'من',
      'To': 'إلى'
    },
    fr: {
      'Home': 'Accueil', 'Shop': 'Boutique', 'Catalog': 'Catalogue', 'Collections': 'Collections',
      'All Products': 'Tous les produits', 'Products': 'Produits', 'Contact': 'Contact', 'About Us': 'À propos',
      'Search': 'Rechercher', 'Account': 'Compte', 'Cart': 'Panier', 'Your Cart': 'Votre Panier',
      'Your Shopping Bag': 'Votre Panier', 'Your cart is empty': 'Votre panier est vide',
      'Continue Shopping': 'Continuer vos achats', 'Subtotal': 'Sous-total', 'Checkout': 'Passer à la caisse',
      'Proceed to Checkout': 'Passer à la caisse', 'Add to Cart': 'Ajouter au panier', 'Add to Bag': 'Ajouter au panier',
      'ADD TO CART': 'AJOUTER AU PANIER', 'ADD TO BAG': 'AJOUTER AU PANIER',
      'Choose Options': 'Choisir les options', 'CHOOSE OPTIONS': 'CHOISIR LES OPTIONS',
      'Buy It Now': 'Acheter maintenant', 'Sold Out': 'Épuisé', 'SOLD OUT': 'ÉPUISÉ', 'Sale': 'Promo', 'SALE': 'PROMO',
      'Best Sellers': 'Meilleures Ventes', 'Featured Collection': 'Collection Vedette',
      'Shop by Category': 'Acheter par Catégorie', 'Shop by Occasion': 'Acheter par Occasion',
      'Shop Now': 'Acheter', 'SHOP NOW': 'ACHETER', 'View All': 'Tout voir', 'VIEW ALL': 'TOUT VOIR',
      'Filter': 'Filtrer', 'Filter & Sort': 'Filtrer et trier', 'Sort by': 'Trier par', 'Sort by:': 'Trier par :',
      'Featured': 'En vedette', 'Best selling': 'Meilleures ventes', 'Price, low to high': 'Prix : croissant',
      'Price, high to low': 'Prix : décroissant', 'Quantity': 'Quantité', 'Description': 'Description',
      'Shipping & Returns': 'Livraison et retours', 'You May Also Like': 'Vous aimerez aussi',
      'Customer Reviews': 'Avis clients', 'Subscribe': "S'inscrire", 'FOR HER': 'POUR ELLE', 'FOR HIM': 'POUR LUI',
      'COUPLES GIFTS': 'CADEAUX COUPLES', 'Rings': 'Bagues', 'Chains': 'Chaînes', 'Bracelets': 'Bracelets',
      'Jewelry Sets': 'Parures de bijoux', 'Watches': 'Montres', 'Bags': 'Sacs',
      'READ FULL ARTICLE →': 'LIRE L’ARTICLE COMPLET →', '◄ PREV': '◄ PRÉC', 'NEXT ►': 'SUIV ►',
      '← العودة إلى المجلة': '← Retour au journal', '◄ المقال السابق': '◄ Article précédent', 'المقال التالي ►': 'Article suivant ►'
    },
    de: {
      'Home': 'Startseite', 'Shop': 'Shop', 'Catalog': 'Katalog', 'Collections': 'Kollektionen',
      'All Products': 'Alle Produkte', 'Products': 'Produkte', 'Contact': 'Kontakt', 'About Us': 'Über uns',
      'Search': 'Suchen', 'Account': 'Konto', 'Cart': 'Warenkorb', 'Your Cart': 'Ihr Warenkorb',
      'Your Shopping Bag': 'Ihr Warenkorb', 'Your cart is empty': 'Ihr Warenkorb ist leer',
      'Continue Shopping': 'Weiter einkaufen', 'Subtotal': 'Zwischensumme', 'Checkout': 'Zur Kasse',
      'Proceed to Checkout': 'Zur Kasse', 'Add to Cart': 'In den Warenkorb', 'Add to Bag': 'In den Warenkorb',
      'ADD TO CART': 'IN DEN WARENKORB', 'ADD TO BAG': 'IN DEN WARENKORB',
      'Choose Options': 'Optionen wählen', 'CHOOSE OPTIONS': 'OPTIONEN WÄHLEN',
      'Buy It Now': 'Sofort kaufen', 'Sold Out': 'Ausverkauft', 'Sale': 'Angebot', 'Best Sellers': 'Bestseller',
      'Shop Now': 'Jetzt shoppen', 'View All': 'Alle ansehen', 'Filter': 'Filtern', 'Sort by': 'Sortieren nach',
      'Quantity': 'Menge', 'You May Also Like': 'Das könnte Ihnen auch gefallen',
      'READ FULL ARTICLE →': 'GANZEN ARTIKEL LESEN →', '◄ PREV': '◄ ZURÜCK', 'NEXT ►': 'WEITER ►',
      '← العودة إلى المجلة': '← Zurück zum Journal', '◄ المقال السابق': '◄ Vorheriger Artikel', 'المقال التالي ►': 'Nächster Artikel ►'
    },
    es: {
      'Home': 'Inicio', 'Shop': 'Tienda', 'Catalog': 'Catálogo', 'Collections': 'Colecciones',
      'All Products': 'Todos los productos', 'Products': 'Productos', 'Contact': 'Contacto', 'About Us': 'Nosotros',
      'Search': 'Buscar', 'Account': 'Cuenta', 'Cart': 'Bolsa', 'Your Cart': 'Tu Bolsa',
      'Your Shopping Bag': 'Tu Bolsa de Compras', 'Your cart is empty': 'Tu bolsa está vacía',
      'Continue Shopping': 'Seguir comprando', 'Subtotal': 'Subtotal', 'Checkout': 'Finalizar compra',
      'Proceed to Checkout': 'Finalizar compra', 'Add to Cart': 'Añadir a la bolsa', 'Add to Bag': 'Añadir a la bolsa',
      'ADD TO CART': 'AÑADIR A LA BOLSA', 'ADD TO BAG': 'AÑADIR A LA BOLSA',
      'Choose Options': 'Elegir opciones', 'CHOOSE OPTIONS': 'ELEGIR OPCIONES',
      'Buy It Now': 'Comprar ahora', 'Sold Out': 'Agotado', 'Sale': 'Oferta', 'Best Sellers': 'Más Vendidos',
      'Shop Now': 'Comprar ahora', 'View All': 'Ver todo', 'Filter': 'Filtrar', 'Sort by': 'Ordenar por',
      'Quantity': 'Cantidad', 'You May Also Like': 'También te puede interesar',
      'READ FULL ARTICLE →': 'LEER ARTÍCULO COMPLETO →', '◄ PREV': '◄ ANT', 'NEXT ►': 'SIG ►',
      '← العودة إلى المجلة': '← Volver al blog', '◄ المقال السابق': '◄ Artículo anterior', 'المقال التالي ►': 'Artículo siguiente ►'
    },
    it: {
      'Home': 'Home', 'Shop': 'Negozio', 'Catalog': 'Catalogo', 'Collections': 'Collezioni',
      'All Products': 'Tutti i prodotti', 'Products': 'Prodotti', 'Contact': 'Contatti', 'About Us': 'Chi siamo',
      'Search': 'Cerca', 'Account': 'Account', 'Cart': 'Carrello', 'Your Cart': 'Il tuo carrello',
      'Your Shopping Bag': 'Il tuo carrello', 'Your cart is empty': 'Il carrello è vuoto',
      'Continue Shopping': 'Continua lo shopping', 'Subtotal': 'Subtotale', 'Checkout': 'Procedi al checkout',
      'Proceed to Checkout': 'Procedi al checkout', 'Add to Cart': 'Aggiungi al carrello', 'Add to Bag': 'Aggiungi al carrello',
      'ADD TO CART': 'AGGIUNGI AL CARRELLO', 'ADD TO BAG': 'AGGIUNGI AL CARRELLO',
      'Choose Options': 'Scegli opzioni', 'CHOOSE OPTIONS': 'SCEGLI OPZIONI',
      'Buy It Now': 'Acquista ora', 'Sold Out': 'Esaurito', 'Sale': 'Saldi', 'Best Sellers': 'Più venduti',
      'Shop Now': 'Acquista ora', 'View All': 'Mostra tutto', 'Filter': 'Filtra', 'Sort by': 'Ordina per',
      'Quantity': 'Quantità', 'You May Also Like': 'Potrebbe piacerti anche',
      'READ FULL ARTICLE →': 'LEGGI ARTICOLO COMPLETO →', '◄ PREV': '◄ PREC', 'NEXT ►': 'SUCC ►',
      '← العودة إلى المجلة': '← Torna al giornale', '◄ المقال السابق': '◄ Articolo precedente', 'المقال التالي ►': 'Articolo successivo ►'
    },
    'pt-BR': {
      'Home': 'Início', 'Shop': 'Loja', 'Catalog': 'Catálogo', 'Collections': 'Coleções',
      'All Products': 'Todos os produtos', 'Products': 'Produtos', 'Contact': 'Contato', 'About Us': 'Sobre nós',
      'Search': 'Buscar', 'Account': 'Conta', 'Cart': 'Sacola', 'Your Cart': 'Sua Sacola',
      'Your Shopping Bag': 'Sua Sacola de Compras', 'Your cart is empty': 'Sua sacola está vazia',
      'Continue Shopping': 'Continuar comprando', 'Subtotal': 'Subtotal', 'Checkout': 'Finalizar compra',
      'Proceed to Checkout': 'Finalizar compra', 'Add to Cart': 'Adicionar à sacola', 'Add to Bag': 'Adicionar à sacola',
      'ADD TO CART': 'ADICIONAR À SACOLA', 'ADD TO BAG': 'ADICIONAR À SACOLA',
      'Choose Options': 'Escolher opções', 'CHOOSE OPTIONS': 'ESCOLHER OPÇÕES',
      'Buy It Now': 'Comprar agora', 'Sold Out': 'Esgotado', 'Best Sellers': 'Mais Vendidos',
      'Shop Now': 'Comprar agora', 'View All': 'Ver tudo', 'Filter': 'Filtrar', 'Sort by': 'Ordenar por',
      'Quantity': 'Quantidade', 'You May Also Like': 'Você também pode gostar',
      'READ FULL ARTICLE →': 'LER ARTIGO COMPLETO →', '◄ PREV': '◄ ANTERIOR', 'NEXT ►': 'PRÓXIMO ►'
    },
    tr: {
      'Home': 'Ana Sayfa', 'Shop': 'Mağaza', 'Catalog': 'Katalog', 'Collections': 'Koleksiyonlar',
      'All Products': 'Tüm Ürünler', 'Products': 'Ürünler', 'Contact': 'İletişim', 'About Us': 'Hakkımızda',
      'Search': 'Ara', 'Account': 'Hesabım', 'Cart': 'Sepet', 'Your Cart': 'Sepetiniz',
      'Continue Shopping': 'Alışverişe Devam Et', 'Subtotal': 'Ara Toplam', 'Checkout': 'Ödemeye Geç',
      'Add to Cart': 'Sepete Ekle', 'Add to Bag': 'Sepete Ekle', 'Buy It Now': 'Hemen Al',
      'Choose Options': 'Seçenekleri Seç', 'CHOOSE OPTIONS': 'SEÇENEKLERİ SEÇ',
      'Sold Out': 'Tükendi', 'Best Sellers': 'Çok Satanlar', 'Shop Now': 'Şimdi Alışveriş Yap',
      'View All': 'Tümünü Gör', 'Filter': 'Filtrele', 'Sort by': 'Sırala', 'Quantity': 'Adet',
      'You May Also Like': 'Bunları da Beğenebilirsiniz',
      'READ FULL ARTICLE →': 'MAKALEYİ OKU →', '◄ PREV': '◄ ÖNCEKİ', 'NEXT ►': 'SONRAKİ ►'
    },
    ru: {
      'Home': 'Главная', 'Shop': 'Магазин', 'Catalog': 'Каталог', 'Collections': 'Коллекции',
      'All Products': 'Все товары', 'Products': 'Товары', 'Contact': 'Контакты', 'About Us': 'О нас',
      'Search': 'Поиск', 'Account': 'Аккаунт', 'Cart': 'Корзина', 'Your Cart': 'Ваша корзина',
      'Continue Shopping': 'Продолжить покупки', 'Subtotal': 'Подытог', 'Checkout': 'Оформить заказ',
      'Add to Cart': 'В корзину', 'Add to Bag': 'В корзину', 'Buy It Now': 'Купить сейчас',
      'Choose Options': 'Выбрать параметры', 'CHOOSE OPTIONS': 'ВЫБРАТЬ ПАРАМЕТРЫ',
      'Sold Out': 'Распродано', 'Best Sellers': 'Хиты продаж', 'Shop Now': 'В магазин',
      'View All': 'Смотреть все', 'Filter': 'Фильтр', 'Sort by': 'Сортировка', 'Quantity': 'Количество',
      'You May Also Like': 'Вам также может понравиться',
      'READ FULL ARTICLE →': 'ЧИТАТЬ СТАТЬЮ ПОЛНОСТЬЮ →', '◄ PREV': '◄ НАЗАД', 'NEXT ►': 'ВПЕРЕД ►'
    },
    nl: {
      'Home': 'Home', 'Shop': 'Winkel', 'Catalog': 'Catalogus', 'Collections': 'Collecties',
      'All Products': 'Alle producten', 'Products': 'Producten', 'Contact': 'Contact', 'About Us': 'Over ons',
      'Search': 'Zoeken', 'Account': 'Account', 'Cart': 'Winkelmand', 'Your Cart': 'Uw winkelmand',
      'Continue Shopping': 'Verder winkelen', 'Subtotal': 'Subtotaal', 'Checkout': 'Afrekenen',
      'Add to Cart': 'In winkelmand', 'Add to Bag': 'In winkelmand', 'Buy It Now': 'Nu kopen',
      'Choose Options': 'Kies opties', 'CHOOSE OPTIONS': 'KIES OPTIES',
      'Sold Out': 'Uitverkocht', 'Best Sellers': 'Bestsellers', 'Shop Now': 'Nu winkelen',
      'View All': 'Alles bekijken', 'Filter': 'Filteren', 'Sort by': 'Sorteren op', 'Quantity': 'Aantal',
      'You May Also Like': 'Misschien vind je dit ook leuk',
      'READ FULL ARTICLE →': 'LEES HET VOLLEDIGE ARTIKEL →', '◄ PREV': '◄ VORIGE', 'NEXT ►': 'VOLGENDE ►'
    },
    ja: {
      'Home': 'ホーム', 'Shop': 'ショップ', 'Catalog': 'カタログ', 'Collections': 'コレクション',
      'All Products': 'すべての商品', 'Products': '商品一覧', 'Contact': 'お問い合わせ', 'About Us': 'ブランドについて',
      'Search': '検索', 'Account': 'アカウント', 'Cart': 'ショッピングバッグ', 'Your Cart': 'ショッピングバッグ',
      'Continue Shopping': '買い物を続ける', 'Subtotal': '小計', 'Checkout': 'ご購入手続きへ',
      'Add to Cart': 'バッグに追加', 'Add to Bag': 'バッグに追加', 'Buy It Now': '今すぐ購入',
      'Choose Options': 'オプションを選択', 'CHOOSE OPTIONS': 'オプションを選択',
      'Sold Out': '完売', 'Best Sellers': 'ベストセラー', 'Shop Now': '今すぐチェック',
      'View All': 'すべて見る', 'Filter': '絞り込み', 'Sort by': '並び替え', 'Quantity': '数量',
      'You May Also Like': 'こちらもおすすめ',
      'READ FULL ARTICLE →': '記事全文を読む →', '◄ PREV': '◄ 前へ', 'NEXT ►': '次へ ►'
    },
    'zh-CN': {
      'Home': '首页', 'Shop': '商城', 'Catalog': '商品目录', 'Collections': '系列',
      'All Products': '全部商品', 'Products': '商品', 'Contact': '联系我们', 'About Us': '关于我们',
      'Search': '搜索', 'Account': '账户', 'Cart': '购物袋', 'Your Cart': '您的购物袋',
      'Continue Shopping': '继续购物', 'Subtotal': '小计', 'Checkout': '前往结账',
      'Add to Cart': '加入购物袋', 'Add to Bag': '加入购物袋', 'Buy It Now': '立即购买',
      'Choose Options': '选择规格', 'CHOOSE OPTIONS': '选择规格',
      'Sold Out': '已售罄', 'Best Sellers': '畅销精品', 'Shop Now': '立即选购',
      'View All': '查看全部', 'Filter': '筛选', 'Sort by': '排序', 'Quantity': '数量',
      'You May Also Like': '猜您喜欢',
      'READ FULL ARTICLE →': '阅读完整专栏 →', '◄ PREV': '◄ 上一篇', 'NEXT ►': '下一篇 ►'
    },
    ko: {
      'Home': '홈', 'Shop': '스토어', 'Catalog': '카탈로그', 'Collections': '컬렉션',
      'All Products': '전체 상품', 'Products': '상품', 'Contact': '문의하기', 'About Us': '브랜드 소개',
      'Search': '검색', 'Account': '계정', 'Cart': '쇼핑백', 'Your Cart': '쇼핑백',
      'Continue Shopping': '쇼핑 계속하기', 'Subtotal': '소계', 'Checkout': '결제하기',
      'Add to Cart': '쇼핑백에 담기', 'Add to Bag': '쇼핑백에 담기', 'Buy It Now': '바로 구매',
      'Choose Options': '옵션 선택', 'CHOOSE OPTIONS': '옵션 선택',
      'Sold Out': '품절', 'Best Sellers': '베스트셀러', 'Shop Now': '지금 쇼핑하기',
      'View All': '전체 보기', 'Filter': '필터', 'Sort by': '정렬', 'Quantity': '수량',
      'You May Also Like': '추천 상품',
      'READ FULL ARTICLE →': '전체 글 읽기 →', '◄ PREV': '◄ 이전', 'NEXT ►': '다음 ►'
    },
    en: {
      'READ FULL ARTICLE →': 'READ FULL ARTICLE →',
      '◄ PREV': '◄ PREV',
      'NEXT ►': 'NEXT ►',
      '← العودة إلى المجلة': '← Back to Journal',
      '◄ المقال السابق': '◄ Previous Article',
      'المقال التالي ►': 'Next Article ►'
    }
  };

  function normalizeLocaleCode(raw) {
    if (!raw || typeof raw !== 'string') return '';
    var clean = raw.trim();
    var lower = clean.toLowerCase();
    if (lower.indexOf('ar') === 0) return 'ar';
    if (lower.indexOf('fr') === 0) return 'fr';
    if (lower.indexOf('de') === 0) return 'de';
    if (lower.indexOf('es') === 0) return 'es';
    if (lower.indexOf('it') === 0) return 'it';
    if (lower.indexOf('pt') === 0) return 'pt-BR';
    if (lower.indexOf('tr') === 0) return 'tr';
    if (lower.indexOf('ru') === 0) return 'ru';
    if (lower.indexOf('nl') === 0) return 'nl';
    if (lower.indexOf('ja') === 0) return 'ja';
    if (lower.indexOf('zh') === 0) return 'zh-CN';
    if (lower.indexOf('ko') === 0) return 'ko';
    if (lower.indexOf('en') === 0) return 'en';
    return '';
  }

  function getUrlLocalePrefix() {
    var path = window.location.pathname || '/';
    var seg = path.split('/')[1] || '';
    var lower = seg.toLowerCase();
    for (var i = 0; i < SUPPORTED_LOCALES.length; i++) {
      if (SUPPORTED_LOCALES[i].toLowerCase() === lower) {
        return SUPPORTED_LOCALES[i];
      }
    }
    return '';
  }

  function getBootstrapData() {
    try {
      var el = document.getElementById('NaggatLocalizationBootstrap');
      if (el && el.textContent) {
        return JSON.parse(el.textContent);
      }
    } catch (e) {}
    return {
      currentLocale: document.documentElement.lang || 'en',
      currentCountry: document.documentElement.getAttribute('data-country') || 'EG',
      countryName: 'Egypt',
      publishedLocales: []
    };
  }

  var bootstrapData = getBootstrapData();

  function isPublishedOrAvailable(localeCode) {
    if (!localeCode) return false;
    var list = bootstrapData.publishedLocales;
    if (!list || !list.length) {
      return SUPPORTED_LOCALES.indexOf(localeCode) !== -1;
    }
    for (var i = 0; i < list.length; i++) {
      if (normalizeLocaleCode(list[i].code) === localeCode) {
        return true;
      }
    }
    return false;
  }

  /**
   * 5-Tier Language Detection Priority (Phase 2.1):
   * 1. Explicit language selection made by visitor (?lang= or /<locale>/ prefix)
   * 2. Previously saved manual language preference (localStorage)
   * 3. Browser preferred language (navigator.languages)
   * 4. Default language assigned to visitor's Shopify Market (Shopify.country / data-country)
   * 5. English as the final fallback ('en')
   */
  function resolveActiveLocale() {
    try {
      var params = new URLSearchParams(window.location.search);
      var qLang = normalizeLocaleCode(params.get('lang') || params.get('locale'));
      if (qLang && isPublishedOrAvailable(qLang)) {
        localStorage.setItem(STORAGE_LANG_KEY, qLang);
        return qLang;
      }
    } catch (e) {}

    var urlPrefix = getUrlLocalePrefix();
    if (urlPrefix && isPublishedOrAvailable(urlPrefix)) {
      return urlPrefix;
    }

    try {
      var saved = normalizeLocaleCode(localStorage.getItem(STORAGE_LANG_KEY));
      if (saved && isPublishedOrAvailable(saved)) return saved;
    } catch (e) {}

    try {
      var navLangs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
      for (var i = 0; i < navLangs.length; i++) {
        var matched = normalizeLocaleCode(navLangs[i]);
        if (matched && isPublishedOrAvailable(matched)) return matched;
      }
    } catch (e) {}

    var country = (window.Shopify && window.Shopify.country) || bootstrapData.currentCountry || document.documentElement.getAttribute('data-country') || '';
    if (country && COUNTRY_TO_LOCALE[country.toUpperCase()]) {
      var marketLocale = COUNTRY_TO_LOCALE[country.toUpperCase()];
      if (isPublishedOrAvailable(marketLocale)) {
        return marketLocale;
      }
    }

    var shopifyLocale = normalizeLocaleCode((window.Shopify && window.Shopify.locale) || bootstrapData.currentLocale || document.documentElement.lang);
    if (shopifyLocale && isPublishedOrAvailable(shopifyLocale)) {
      return shopifyLocale;
    }

    return 'en';
  }

  function applyDirectionAndLang(locale) {
    var isRtl = locale === 'ar';
    var html = document.documentElement;
    html.setAttribute('lang', locale);
    html.setAttribute('dir', isRtl ? 'rtl' : 'ltr');
    html.setAttribute('data-active-locale', locale);
    if (document.body) {
      document.body.classList.toggle('is-rtl', isRtl);
      document.body.classList.toggle('is-ltr', !isRtl);
    }
  }

  function translateDOMNodes(locale) {
    if (locale === 'en') return;
    var dict = UI_TRANSLATIONS[locale];
    if (!dict) return;

    var runTranslation = function () {
      var selectors = [
        'nav a', '.header-nav__link', '.mobile-menu__link', '.section-title', '.section-head h2',
        '.btn', 'button:not([data-xo-cell]):not(.xo-lang-option)', '.cart-drawer__title',
        '.footer-col__title', '.footer-links a', '.breadcrumb a', '.article-back', '.article-nav a',
        '.product-card__badge', '.collection-toolbar label', '.collection-toolbar option',
        '.product-card__btn', '[data-translate-ui]'
      ].join(',');

      var elements = document.querySelectorAll(selectors);
      for (var i = 0; i < elements.length; i++) {
        var el = elements[i];
        if (el.children.length === 0) {
          var orig = el.getAttribute('data-orig-text');
          if (!orig) {
            orig = (el.textContent || '').trim();
            if (orig) el.setAttribute('data-orig-text', orig);
          }
          if (orig && dict[orig]) {
            el.textContent = dict[orig];
          }
        }
      }
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(runTranslation, { timeout: 1000 });
    } else {
      setTimeout(runTranslation, 50);
    }
  }

  function buildLocalizedPath(targetLocale) {
    var path = window.location.pathname || '/';
    var segs = path.split('/');
    var first = (segs[1] || '').toLowerCase();
    for (var i = 0; i < SUPPORTED_LOCALES.length; i++) {
      if (SUPPORTED_LOCALES[i].toLowerCase() === first) {
        segs.splice(1, 1);
        break;
      }
    }
    var cleanPath = segs.join('/') || '/';
    if (!cleanPath.startsWith('/')) cleanPath = '/' + cleanPath;

    if (targetLocale === 'en') {
      return cleanPath + window.location.search + window.location.hash;
    }
    var prefix = '/' + targetLocale.toLowerCase();
    var finalPath = cleanPath === '/' ? prefix : prefix + cleanPath;
    return finalPath + window.location.search + window.location.hash;
  }

  function isBotOrCrawler() {
    var ua = (navigator.userAgent || '').toLowerCase();
    return /bot|crawler|spider|googlebot|bingbot|yandex|baiduspider|duckduckbot|slurp|lighthouse|chrome-lighthouse/i.test(ua);
  }

  /* ==========================================================================
     SMART LANGUAGE SELECTION POPUP & ONBOARDING SEQUENCE (PHASE 1, 2, 3)
     ========================================================================== */

  var MODAL_I18N = {
    ar: {
      eyebrow: 'NAGGAT SILVER · نجاة سيلفر',
      title: 'مرحباً بكم في نجاة سيلفر',
      desc: 'هل تفضل تصفح المتجر باللغة العربية أم الإنجليزية؟',
      primaryLabel: 'العربية',
      secondaryLabel: 'English',
      dismiss: 'المتابعة باللغة الحالية'
    },
    fr: {
      eyebrow: 'NAGGAT SILVER · PARIS & CAIRO',
      title: 'BIENVENUE CHEZ NAGGAT SILVER',
      desc: 'Souhaitez-vous naviguer en français ou en anglais ?',
      primaryLabel: 'Français',
      secondaryLabel: 'English',
      dismiss: 'Continuer en anglais'
    },
    de: {
      eyebrow: 'NAGGAT SILVER · FINE JEWELRY',
      title: 'WILLKOMMEN BEI NAGGAT SILVER',
      desc: 'Möchten Sie lieber auf Deutsch oder Englisch stöbern?',
      primaryLabel: 'Deutsch',
      secondaryLabel: 'English',
      dismiss: 'Auf Englisch fortfahren'
    },
    es: {
      eyebrow: 'NAGGAT SILVER · JOYERÍA FINA',
      title: 'BIENVENIDO A NAGGAT SILVER',
      desc: '¿Prefieres navegar en español o en inglés?',
      primaryLabel: 'Español',
      secondaryLabel: 'English',
      dismiss: 'Continuar en inglés'
    },
    it: {
      eyebrow: 'NAGGAT SILVER · ALTA GIOIELLERIA',
      title: 'BENVENUTO A NAGGAT SILVER',
      desc: 'Preferisci navigare in italiano o in inglese?',
      primaryLabel: 'Italiano',
      secondaryLabel: 'English',
      dismiss: 'Continua in inglese'
    },
    ja: {
      eyebrow: 'NAGGAT SILVER · 銀製ジュエリー',
      title: 'ナガットシルバーへようこそ',
      desc: '日本語または英語でブラウズしますか？',
      primaryLabel: '日本語',
      secondaryLabel: 'English',
      dismiss: '英語で続ける'
    },
    en: {
      eyebrow: 'NAGGAT SILVER · STERLING SILVER',
      title: 'WELCOME TO NAGGAT SILVER',
      desc: 'Would you prefer to browse in Arabic or English?',
      primaryLabel: 'العربية',
      secondaryLabel: 'English',
      dismiss: 'Continue in English'
    }
  };

  function selectLanguage(targetLocale) {
    try {
      localStorage.setItem(STORAGE_LANG_KEY, targetLocale);
      localStorage.setItem('naggat_lang_selected', 'true');
      sessionStorage.setItem(POPUP_DISMISSED_KEY, '1');
    } catch (e) {}

    closeLanguageModal('selection');

    var current = normalizeLocaleCode(bootstrapData.currentLocale || document.documentElement.lang) || 'en';
    if (targetLocale === current) {
      applyDirectionAndLang(targetLocale);
      translateDOMNodes(targetLocale);
      return;
    }

    // Submit Shopify Native Localization Form (Phase 3.4)
    var nativeForm = document.getElementById('NaggatNativeLocalizationForm');
    var nativeInput = document.getElementById('NaggatNativeLocaleInput');
    if (nativeForm && nativeInput) {
      nativeInput.value = targetLocale;
      try {
        nativeForm.submit();
        return;
      } catch (err) {}
    }

    // Direct path fallback navigation (preserves cart & localStorage XO reward)
    var dest = buildLocalizedPath(targetLocale);
    if (dest !== (window.location.pathname + window.location.search + window.location.hash)) {
      window.location.href = dest;
    }
  }

  function closeLanguageModal(reason) {
    var modal = document.getElementById('NaggatLangModal');
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.body.classList.remove('has-lang-modal');

    window.__NaggatLanguageActive = false;
    window.__NaggatLanguageCompleted = true;

    try {
      sessionStorage.setItem(POPUP_DISMISSED_KEY, '1');
      if (reason === 'dismiss') {
        localStorage.setItem('naggat_lang_dismissed_time', Date.now().toString());
      }
    } catch (e) {}

    // Dispatch event so XO game can open after language is handled
    try {
      window.dispatchEvent(new CustomEvent('naggat:language_completed', { detail: { reason: reason } }));
    } catch (e) {}

    // Trigger XO game directly if loaded
    setTimeout(function () {
      if (window.NaggatXoGame && typeof window.NaggatXoGame.triggerOnboarding === 'function') {
        window.NaggatXoGame.triggerOnboarding();
      }
    }, 450);
  }

  function openLanguageModal() {
    var modal = document.getElementById('NaggatLangModal');
    if (!modal) return;

    window.__NaggatLanguageActive = true;

    var country = (bootstrapData.currentCountry || document.documentElement.getAttribute('data-country') || 'EG').toUpperCase();
    var countryName = bootstrapData.countryName || COUNTRY_NAMES_EN[country] || country;

    var recommendedLang = COUNTRY_TO_LOCALE[country] || 'en';
    if (!isPublishedOrAvailable(recommendedLang)) {
      recommendedLang = 'en';
    }

    // For Arab countries, recommend Arabic (with English option)
    if (ARABIC_COUNTRIES[country]) {
      recommendedLang = 'ar';
    }

    var i18nConfig = MODAL_I18N[recommendedLang] || MODAL_I18N.en;

    // Set modal direction
    var isModalRtl = recommendedLang === 'ar';
    modal.setAttribute('dir', isModalRtl ? 'rtl' : 'ltr');

    // Populate copy
    var eyebrowEl = modal.querySelector('[data-lang-i18n="eyebrow"]');
    if (eyebrowEl) eyebrowEl.textContent = i18nConfig.eyebrow;

    var titleEl = modal.querySelector('[data-lang-i18n="title"]');
    if (titleEl) titleEl.textContent = i18nConfig.title;

    var descEl = modal.querySelector('[data-lang-i18n="desc"]');
    if (descEl) descEl.textContent = i18nConfig.desc;

    var dismissEl = modal.querySelector('[data-lang-i18n="dismiss"]');
    if (dismissEl) dismissEl.textContent = i18nConfig.dismiss;

    var countryTagEl = modal.querySelector('[data-lang-country-label]');
    if (countryTagEl) {
      countryTagEl.textContent = countryName;
    }

    // Populate buttons
    var optionsWrap = modal.querySelector('[data-lang-options]');
    if (optionsWrap) {
      optionsWrap.innerHTML = '';

      var primaryCode = recommendedLang !== 'en' ? recommendedLang : 'en';
      var secondaryCode = recommendedLang !== 'en' ? 'en' : 'ar';

      var btn1 = document.createElement('button');
      btn1.type = 'button';
      btn1.className = 'naggat-lang-btn naggat-lang-btn--primary' + (primaryCode === 'ar' ? ' naggat-lang-btn--ar' : '');
      btn1.setAttribute('data-target-locale', primaryCode);
      btn1.textContent = i18nConfig.primaryLabel;
      btn1.addEventListener('click', function () {
        selectLanguage(primaryCode);
      });
      optionsWrap.appendChild(btn1);

      var btn2 = document.createElement('button');
      btn2.type = 'button';
      btn2.className = 'naggat-lang-btn naggat-lang-btn--secondary' + (secondaryCode === 'ar' ? ' naggat-lang-btn--ar' : '');
      btn2.setAttribute('data-target-locale', secondaryCode);
      btn2.textContent = i18nConfig.secondaryLabel;
      btn2.addEventListener('click', function () {
        selectLanguage(secondaryCode);
      });
      optionsWrap.appendChild(btn2);
    }

    modal.hidden = false;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-lang-modal');
  }

  function shouldShowLanguageModal() {
    // Disabled: User requested language selector popup at beginning removed
    return false;
  }

  function initLanguageModalSequence() {
    window.__NaggatLanguageActive = false;
    window.__NaggatLanguageCompleted = true;
    try {
      window.dispatchEvent(new CustomEvent('naggat:language_completed', { detail: { reason: 'disabled' } }));
    } catch (e) {}
  }

  function initLanguageSwitchers(activeLocale) {
    var selects = document.querySelectorAll('[data-naggat-lang-select]');
    for (var i = 0; i < selects.length; i++) {
      var sel = selects[i];
      for (var j = 0; j < sel.options.length; j++) {
        if (normalizeLocaleCode(sel.options[j].value) === activeLocale) {
          sel.selectedIndex = j;
          break;
        }
      }
      if (!sel.dataset.bound) {
        sel.dataset.bound = 'true';
        sel.addEventListener('change', function (e) {
          var chosen = normalizeLocaleCode(e.target.value) || 'en';
          selectLanguage(chosen);
        });
      }
    }
  }

  /* ==========================================================================
     SMART SCROLL POSITION RESTORATION (SECTION 6 & PHASE 11)
     ========================================================================== */
  function getPageScrollKey(urlStr) {
    try {
      var u = new URL(urlStr || window.location.href, window.location.origin);
      return u.pathname + u.search;
    } catch (e) {
      return window.location.pathname + window.location.search;
    }
  }

  function readScrollMap() {
    try {
      var raw = sessionStorage.getItem(SCROLL_STORE_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  function saveCurrentScrollPosition(extra) {
    try {
      var key = getPageScrollKey();
      var map = readScrollMap();
      map[key] = {
        y: Math.max(0, Math.round(window.scrollY || window.pageYOffset || 0)),
        x: Math.max(0, Math.round(window.scrollX || window.pageXOffset || 0)),
        ts: Date.now(),
        vw: window.innerWidth,
        anchorSelector: (extra && extra.anchorSelector) || (map[key] && map[key].anchorSelector) || null
      };
      var keys = Object.keys(map);
      if (keys.length > 40) {
        keys.sort(function (a, b) { return (map[a].ts || 0) - (map[b].ts || 0); });
        delete map[keys[0]];
      }
      sessionStorage.setItem(SCROLL_STORE_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  function isBackForwardNavigation() {
    try {
      if (window.performance && performance.getEntriesByType) {
        var navEntries = performance.getEntriesByType('navigation');
        if (navEntries && navEntries.length && navEntries[0].type === 'back_forward') {
          return true;
        }
      }
      if (window.performance && performance.navigation && performance.navigation.type === 2) {
        return true;
      }
      var lastCtxRaw = sessionStorage.getItem(LAST_NAV_KEY);
      if (lastCtxRaw) {
        var lastCtx = JSON.parse(lastCtxRaw);
        if (lastCtx && lastCtx.fromKey === getPageScrollKey() && (Date.now() - lastCtx.ts < 600000)) {
          return true;
        }
      }
    } catch (e) {}
    return false;
  }

  function restoreScrollIfApplicable() {
    if (window.location.hash && window.location.hash.length > 1) return;

    var key = getPageScrollKey();
    var map = readScrollMap();
    var record = map[key];
    if (!record || typeof record.y !== 'number' || record.y <= 10) return;

    if (!isBackForwardNavigation()) return;

    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    var targetY = record.y;
    var attempts = 0;
    var maxAttempts = 12;

    function attemptScroll() {
      attempts++;
      var maxScrollable = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      if (maxScrollable >= targetY * 0.85 || attempts >= maxAttempts) {
        window.scrollTo({ top: targetY, left: record.x || 0, behavior: 'instant' });
      }
      if (Math.abs((window.scrollY || 0) - targetY) > 24 && attempts < maxAttempts) {
        setTimeout(attemptScroll, 75);
      }
    }

    requestAnimationFrame(attemptScroll);
    window.addEventListener('load', function () {
      if (Math.abs((window.scrollY || 0) - targetY) > 24) {
        window.scrollTo({ top: targetY, left: record.x || 0, behavior: 'instant' });
      }
    }, { once: true });
  }

  function bindScrollTracking() {
    var scrollTimer = null;
    window.addEventListener('scroll', function () {
      if (scrollTimer) return;
      scrollTimer = setTimeout(function () {
        scrollTimer = null;
        saveCurrentScrollPosition();
      }, 120);
    }, { passive: true });

    document.addEventListener('click', function (e) {
      var link = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

      var cardSelector = null;
      var productCard = link.closest('[data-product-id], .product-card');
      if (productCard && productCard.getAttribute('data-product-id')) {
        cardSelector = '[data-product-id="' + productCard.getAttribute('data-product-id') + '"]';
      }

      // Non-blocking asynchronous metadata persistence
      setTimeout(function () {
        saveCurrentScrollPosition({ anchorSelector: cardSelector });
        try {
          sessionStorage.setItem(LAST_NAV_KEY, JSON.stringify({
            fromKey: getPageScrollKey(),
            toHref: href,
            ts: Date.now()
          }));
        } catch (err) {}
      }, 0);
    }, { passive: true });

    window.addEventListener('pagehide', function () {
      saveCurrentScrollPosition();
    });

    window.addEventListener('popstate', function () {
      setTimeout(restoreScrollIfApplicable, 10);
    });
  }

  /* Public API */
  window.NaggatLocalization = {
    getActiveLocale: function () { return activeLocale; },
    openModal: openLanguageModal,
    closeModal: closeLanguageModal,
    setLocale: selectLanguage
  };

  /* Initialize immediately */
  var activeLocale = resolveActiveLocale();
  applyDirectionAndLang(activeLocale);
  restoreScrollIfApplicable();
  bindScrollTracking();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyDirectionAndLang(activeLocale);
      initLanguageSwitchers(activeLocale);
      translateDOMNodes(activeLocale);
      initLanguageModalSequence();
    });
  } else {
    initLanguageSwitchers(activeLocale);
    translateDOMNodes(activeLocale);
    initLanguageModalSequence();
  }
})();
